import { createEditBlock } from "./base-edit-block";

export const grammarFixerBlock = createEditBlock("grammar-fixer", {
  responseToPatch: (text) => ({ text }),
});
